var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"vip-gift-btn",on:{"click":_vm.handleClick}},[_c('ym-icon',{staticClass:"icon",attrs:{"name":"vip-gift"}}),_vm._v("\n  赠送\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }